export default {
    // 中
    zhCN: {
        dictionary_name: '字典名称',
        creater: '创建人',
        dictionary_code: '字典代码',
        code_type: '类型代码',
        code_type_name: '类型名称',
        creation_time: '创建时间',
        dict_new: '字典新增',
        dict_edit: '字典编辑',
        lang: '语言',
        sort: '排序',
    },
    // 英
    enUS: {
        dictionary_name: 'Dictionary name',
        creater: 'Creater',
        dictionary_code: 'Dictionary code',
        code_type: 'Code type',
        code_type_name: 'Code type name',
        creation_time: 'Creation time',
        dict_new: 'Dict new',
        dict_edit: 'Dict edit',
        lang: 'Lang',
        sort: 'Sort',
    },
    // 德
    deDE: {
        dictionary_name: 'Wörterbuchname',
        creater: 'Ersteller',
        dictionary_code: 'Wörterbuchcode',
        code_type: 'Code Typ',
        code_type_name: 'Code Typ Name',
        creation_time: 'Erstellungszeit',
        dict_new: 'Neues Wörterbuch',
        dict_edit: 'Wörterbuch bearbeiten',
        lang: 'Sprache',
        sort: 'Sortieren',
    },
    // 法
    frFR: {
        dictionary_name: 'Nom du dictionnaire',
        creater: 'Créateur',
        dictionary_code: 'Code du dictionnaire',
        code_type: 'Type de code',
        code_type_name: 'Nom du type de code',
        creation_time: 'Heure de création',
        dict_new: 'Nouveau dictionnaire',
        dict_edit: 'Modifier le dictionnaire',
        lang: 'Langue',
        sort: 'Trier',
    },
    // 意大利
    itIT: {
        dictionary_name: 'Nome del Dizionario',
        creater: 'Creatore',
        dictionary_code: 'Codice del Dizionario',
        code_type: 'Tipo di Codice',
        code_type_name: 'Nome del Tipo di Codice',
        creation_time: 'Data di Creazione',
        dict_new: 'Nuovo Dizionario',
        dict_edit: 'Modifica Dizionario',
        lang: 'Lingua',
        sort: 'Ordinamento',
    },
    // 荷兰
    nlNL: {
        dictionary_name: 'Woordenboeknaam',
        creater: 'Maker',
        dictionary_code: 'Woordenboekcode',
        code_type: 'Code Type',
        code_type_name: 'Code Type Naam',
        creation_time: 'Aanmaaktijd',
        dict_new: 'Nieuw Woordenboek',
        dict_edit: 'Bewerk Woordenboek',
        lang: 'Taal',
        sort: 'Sorteren',
    },
    // 越南
    viVN: {
        dictionary_name: 'Tên từ điển',
        creater: 'Người tạo',
        dictionary_code: 'Mã từ điển',
        code_type: 'Mã loại',
        code_type_name: 'Tên loại mã',
        creation_time: 'Thời gian tạo',
        dict_new: 'Thêm mới từ điển',
        dict_edit: 'Chỉnh sửa từ điển',
        lang: 'Ngôn ngữ',
        sort: 'Sắp xếp',
    },
    // 西班牙
    esES: {
        dictionary_name: 'Nombre del diccionario',
        creater: 'Creador',
        dictionary_code: 'Código del diccionario',
        code_type: 'Código de tipo',
        code_type_name: 'Nombre de tipo',
        creation_time: 'Fecha de creación',
        dict_new: 'Añadir al diccionario',
        dict_edit: 'Editar el diccionario',
        lang: 'Idioma',
        sort: 'Ordenar',
    },
    // 葡萄牙
    ptBR: {
        dictionary_name: 'Nome do dicionário',
        creater: 'Criador',
        dictionary_code: 'Código do dicionário',
        code_type: 'Tipo de código',
        code_type_name: 'Nome do tipo de código',
        creation_time: 'Data de criação',
        dict_new: 'Novo dicionário',
        dict_edit: 'Edição do dicionário',
        lang: 'Idioma',
        sort: 'Classificação',
    },
    // 波兰
    plPL: {
        dictionary_name: 'Nazwa słownikowa',
        creater: 'Założone przez',
        dictionary_code: 'Kod słownika',
        code_type: 'Typ kodu',
        code_type_name: 'Nazwa typu kodu',
        creation_time: 'Czas założenia',
        dict_new: 'Nowy wpis',
        dict_edit: 'Edycja słownika',
        lang: 'Język',
        sort: 'Sortowanie',
    },
    // 土耳其
    trTR: {
        dictionary_name: 'Sözlük İsmi',
        creater: 'Oluşturucu',
        dictionary_code: 'Sözlük Kodu',
        code_type: 'Kod Türü',
        code_type_name: 'Kod Türü İsmi',
        creation_time: 'Oluşturma Zamanı',
        dict_new: 'Sözlük eklendi',
        dict_edit: 'Sözlük düzeltildi',
        lang: 'Dil',
        sort: 'Sırala',
    },
    // 捷克语
    csCZ: {
        dictionary_name: 'Název slovníku',
        creater: 'Tvůrce',
        dictionary_code: 'Kód slovníku',
        code_type: 'Typ kódu',
        code_type_name: 'Typu kódu',
        creation_time: 'Čas vytvoření',
        dict_new: 'Dict new',
        dict_edit: 'Dict edit',
        lang: 'Jazyk',
        sort: 'Řazení',
    },
    // 匈牙利语
    huHU: {
        dictionary_name: 'Könyvtár neve',
        creater: 'Létrehozó',
        dictionary_code: 'Könyvtárkód',
        code_type: 'Kódtípus',
        code_type_name: 'Kódtípus neve',
        creation_time: 'Létrehozás ideje',
        dict_new: 'Új könyvt.',
        dict_edit: 'Könyvt. szerk.',
        lang: 'Nyelv',
        sort: 'Rendezés',
    },
    // 俄罗斯语
    ruRU: {
        dictionary_name: 'Название словаря',
        creater: 'Создатель',
        dictionary_code: 'Код словаря',
        code_type: 'Тип кода',
        code_type_name: 'Название типа кода',
        creation_time: 'Дата создания',
        dict_new: 'Добавление словаря',
        dict_edit: 'Редактирование словаря',
        lang: 'Язык',
        sort: 'Сортировка',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        dictionary_name: 'اسم القاموس',
        creater: 'المنشئ',
        dictionary_code: 'رمز القاموس',
        code_type: 'رمز النوع',
        code_type_name: 'اسم النوع',
        creation_time: 'وقت الإنشاء',
        dict_new: 'إضافة قاموس جديد',
        dict_edit: 'تحرير القاموس',
        lang: 'اللغة',
        sort: 'الترتيب',
    },
    // 保加利亚语
    bgBG: {
        dictionary_name: 'Име на речника',
        creater: 'Създател',
        dictionary_code: 'Код на речника',
        code_type: 'Код на типа',
        code_type_name: 'Име на типа',
        creation_time: 'Време на създаване',
        dict_new: 'Нов речник',
        dict_edit: 'Редактиране на речник',
        lang: 'Език',
        sort: 'Подреждане',
    },
    // 丹麦语
    daDK: {
        dictionary_name: 'Ordbogsnavn',
        creater: 'Opretter',
        dictionary_code: 'Ordbogskode',
        code_type: 'Typekode',
        code_type_name: 'Typenavn',
        creation_time: 'Oprettelsestidspunkt',
        dict_new: 'Ny ordbog',
        dict_edit: 'Redigér ordbog',
        lang: 'Sprog',
        sort: 'Sortering',
    },
    // 芬兰语
    fiFI: {
        dictionary_name: 'Sanaston nimi',
        creater: 'Luoja',
        dictionary_code: 'Sanastokoodi',
        code_type: 'Tyyppikoodi',
        code_type_name: 'Tyyppinimi',
        creation_time: 'Luontiaika',
        dict_new: 'Uusi sanasto',
        dict_edit: 'Muokkaa sanastoa',
        lang: 'Kieli',
        sort: 'Lajittelu',
    },
    // 繁体中文（台湾）
    zhTW: {
        dictionary_name: '字典名稱',
        creater: '創建人',
        dictionary_code: '字典代碼',
        code_type: '類型代碼',
        code_type_name: '類型名稱',
        creation_time: '創建時間',
        dict_new: '新增字典',
        dict_edit: '編輯字典',
        lang: '語言',
        sort: '排序',
    },
    // 克罗地亚语
    hrHR: {
        dictionary_name: 'Naziv rječnika',
        creater: 'Kreator',
        dictionary_code: 'Kôd rječnika',
        code_type: 'Kôd tipa',
        code_type_name: 'Naziv tipa',
        creation_time: 'Vrijeme stvaranja',
        dict_new: 'Novi rječnik',
        dict_edit: 'Uređivanje rječnika',
        lang: 'Jezik',
        sort: 'Poredak',
    },
    // 拉脱维亚语
    lvLV: {
        dictionary_name: 'Vārdnīcas nosaukums',
        creater: 'Izveidotājs',
        dictionary_code: 'Vārdnīcas kods',
        code_type: 'Tipa kods',
        code_type_name: 'Tipa nosaukums',
        creation_time: 'Izveidošanas laiks',
        dict_new: 'Jauna vārdnīca',
        dict_edit: 'Rediģēt vārdnīcu',
        lang: 'Valoda',
        sort: 'Kārtot',
    },
    // 立陶宛语
    ltLT: {
        dictionary_name: 'Žodyno pavadinimas',
        creater: 'Kūrėjas',
        dictionary_code: 'Žodyno kodas',
        code_type: 'Tipo kodas',
        code_type_name: 'Tipo pavadinimas',
        creation_time: 'Sukūrimo laikas',
        dict_new: 'Naujas žodynas',
        dict_edit: 'Redaguoti žodyną',
        lang: 'Kalba',
        sort: 'Rūšiavimas',
    },
    // 罗马尼亚语
    roRO: {
        dictionary_name: 'Numele dicționarului',
        creater: 'Creator',
        dictionary_code: 'Codul dicționarului',
        code_type: 'Codul tipului',
        code_type_name: 'Numele tipului',
        creation_time: 'Data creării',
        dict_new: 'Adăugare dicționar',
        dict_edit: 'Editare dicționar',
        lang: 'Limbă',
        sort: 'Sortare',
    },
    // 挪威博克马尔语
    nbNO: {
        dictionary_name: 'Ordboksnavn',
        creater: 'Oppretter',
        dictionary_code: 'Ordbokskode',
        code_type: 'Typekode',
        code_type_name: 'Typenavn',
        creation_time: 'Opprettelsestidspunkt',
        dict_new: 'Ny ordbok',
        dict_edit: 'Rediger ordbok',
        lang: 'Språk',
        sort: 'Sortering',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        dictionary_name: 'Nome do dicionário',
        creater: 'Criador',
        dictionary_code: 'Código do dicionário',
        code_type: 'Código do tipo',
        code_type_name: 'Nome do tipo',
        creation_time: 'Data de criação',
        dict_new: 'Novo dicionário',
        dict_edit: 'Editar dicionário',
        lang: 'Idioma',
        sort: 'Ordenação',
    },
    // 瑞典语
    svSE: {
        dictionary_name: 'Ordlistans namn',
        creater: 'Skapare',
        dictionary_code: 'Ordlistkod',
        code_type: 'Typkod',
        code_type_name: 'Typnamn',
        creation_time: 'Skapelsedatum',
        dict_new: 'Ny ordlista',
        dict_edit: 'Redigera ordlista',
        lang: 'Språk',
        sort: 'Sortering',
    },
    // 斯洛伐克语
    skSK: {
        dictionary_name: 'Názov slovníka',
        creater: 'Tvorca',
        dictionary_code: 'Kód slovníka',
        code_type: 'Kód typu',
        code_type_name: 'Názov typu',
        creation_time: 'Čas vytvorenia',
        dict_new: 'Nový slovník',
        dict_edit: 'Úprava slovníka',
        lang: 'Jazyk',
        sort: 'Zoradenie',
    },
    // 斯洛文尼亚语
    slSI: {
        dictionary_name: 'Ime slovarja',
        creater: 'Ustvarilec',
        dictionary_code: 'Koda slovarja',
        code_type: 'Koda tipa',
        code_type_name: 'Ime tipa',
        creation_time: 'Čas ustvarjanja',
        dict_new: 'Nov slovar',
        dict_edit: 'Urejanje slovarja',
        lang: 'Jezik',
        sort: 'Razvrščanje',
    },
    // 泰语
    thTH: {
        dictionary_name: 'ชื่อพจนานุกรม',
        creater: 'ผู้สร้าง',
        dictionary_code: 'รหัสพจนานุกรม',
        code_type: 'รหัสประเภท',
        code_type_name: 'ชื่อประเภท',
        creation_time: 'เวลาสร้าง',
        dict_new: 'เพิ่มพจนานุกรมใหม่',
        dict_edit: 'แก้ไขพจนานุกรม',
        lang: 'ภาษา',
        sort: 'เรียงลำดับ',
    },
    // 乌克兰语
    ukUA: {
        dictionary_name: 'Назва словника',
        creater: 'Автор',
        dictionary_code: 'Код словника',
        code_type: 'Код типу',
        code_type_name: 'Назва типу',
        creation_time: 'Час створення',
        dict_new: 'Новий словник',
        dict_edit: 'Редагувати словник',
        lang: 'Мова',
        sort: 'Сортування',
    },
    // 希腊语
    elGR: {
        dictionary_name: 'Όνομα λεξικού',
        creater: 'Δημιουργός',
        dictionary_code: 'Κωδικός λεξικού',
        code_type: 'Κωδικός τύπου',
        code_type_name: 'Όνομα τύπου',
        creation_time: 'Ώρα δημιουργίας',
        dict_new: 'Νέο λεξικό',
        dict_edit: 'Επεξεργασία λεξικού',
        lang: 'Γλώσσα',
        sort: 'Ταξινόμηση',
    },
    // 爱沙尼亚语
    etEE: {
        dictionary_name: 'Sõnastiku nimi',
        creater: 'Looja',
        dictionary_code: 'Sõnastiku kood',
        code_type: 'Tüübi kood',
        code_type_name: 'Tüübi nimi',
        creation_time: 'Loomise aeg',
        dict_new: 'Uus sõnastik',
        dict_edit: 'Muuda sõnastikku',
        lang: 'Keel',
        sort: 'Sorteerimine',
    },
    // 哈萨克语
    kkKZ: {
        dictionary_name: 'Сөздік атауы',
        creater: 'Құрастырушы',
        dictionary_code: 'Сөздік коды',
        code_type: 'Түр коды',
        code_type_name: 'Түр атауы',
        creation_time: 'Құрылған уақыты',
        dict_new: 'Жаңа сөздік',
        dict_edit: 'Сөздікті түзету',
        lang: 'Тіл',
        sort: 'Сұрыптау',
    },
    // 希伯来语
    heIL: {
        dictionary_name: 'שם המילון',
        creater: 'יוצר',
        dictionary_code: 'קוד מילון',
        code_type: 'קוד סוג',
        code_type_name: 'שם סוג',
        creation_time: 'תאריך יצירה',
        dict_new: 'מילון חדש',
        dict_edit: 'עריכת מילון',
        lang: 'שפה',
        sort: 'מיון',
    },
};
